import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Desicion2Component } from '../../dialogs/desicion2/desicion2.component';
import {CrearCasoTareasComponent} from '../crear-caso/c-caso.component';
import {CasoTareaService, CasoTareaModel} from 'src/app/services/casos_tareas.service';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import {VerTareaComponent} from '../ver-tarea/ver-tarea.component';
import {TareaCasoService, TareaCasoModel} from 'src/app/services/tareacaso.service';
import {CasosArchivadosComponent} from '../casos-archivados/casos-archivados.component';
import {ObservacionFinalComponent} from '../observacion-final/observacion-final.component';
import {NotificacionService} from 'src/app/services/notificaciones.service';
import { Socket } from 'ngx-socket-io';
import { RolService } from 'src/app/services/rol.service';
import { UserService } from 'src/app/services/user.service';
import {
  ActivatedRoute,
  Event,
  NavigationEnd,
  NavigationStart,
  Router,
} from '@angular/router';
import { SelectFilterComponent } from './select-filter/select-filter.component';
import { async } from '@angular/core/testing';

@Component({
  selector: 'casos-dash',
  templateUrl: './casos.component.html',
  styleUrls: ['./casos.component.scss'],
})
export class CasosTareasComponent implements OnInit {
  @ViewChild('selectFilter') selectFilter: SelectFilterComponent;
  permisosStr: string = null;
  search: string = '';
  casos: CasoTareaModel[] = [];
  casosOriginal: CasoTareaModel[] = [];

  PorAsignar: CasoTareaModel[] = [];
  EnEjecucion: CasoTareaModel[] = [];
  Bloqueado: CasoTareaModel[] = [];
  Finalizado: CasoTareaModel[] = [];

  inteligenciaCount: number = 0;
  retencionCount: number = 0;
  gruposvipCount: number = 0;
  asuntosInternosCount: number = 0;
  inteligenciaCheck: boolean = true;
  retencionCheck: boolean = true;
  gruposvipCheck: boolean = true;
  asuntosInternosCheck: boolean = true;
  analista;
  gerente;
  correo_usuario: string = sessionStorage.getItem('correo');

  constructor(
    public _casos: CasoTareaService,
    public _tareacaso: TareaCasoService,
    public dialog: MatDialog,
    private socket: Socket,
    private _snackBar: MatSnackBar,
    private _notification: NotificacionService,
    private rolService: RolService,
    public userService: UserService,
    private router: ActivatedRoute,
    private route: Router
  ) {
    this.route.events.subscribe(async (event: Event) => {
      if (event instanceof NavigationEnd) {
        //do something on end activity
        this.valueCase = this.router.snapshot.paramMap.get('case');
        // await this.changedCheckbox2(this.actualFilter)
        if (this.valueCase == 'externos') {
          this.text.Caso = 'Solicitud';
          this.text.Casos = 'Solicitudes';
          this.text.caso = 'solicitud';
          this.text.casos = 'solicitudes';
        } else {
          this.text = {
            Caso: 'Caso',
            Casos: 'Casos',
            caso: 'caso',
            casos: 'casos',
          };
        }
        sessionStorage.setItem('type_case', this.valueCase);
      }
    });
    this.permisosStr = this.rolService.permisos.toString();
    this.analista =
      this.permisosStr.includes('Analista de Casos Asuntos Internos') ||
      this.permisosStr.includes('Analista de Casos Asuntos Externos') ||
      this.permisosStr.includes('Analista de Casos Inteligencia') ||
      this.permisosStr.includes('analystRas');
    this.gerente =
      this.permisosStr.includes('Admininistrador Casos de inteligencia') ||
      this.permisosStr.includes('Administrador Casos de Asuntos Externos') ||
      this.permisosStr.includes('Administrador Casos de Asuntos Internos') ||
      this.permisosStr.includes('managerRas') ||
      this.permisosStr.includes('complianceOfficerRas') ||
      this.socket.on('recarga_caso', async (msj: { ok: boolean }) => {
        // this.getCasos()
        await this.changedCheckbox2(this.actualFilter);
      });
    // this.getCasos()
  }
  //Textos que cambian si el tipo de caso es externos
  text = {
    Caso: 'Caso',
    Casos: 'Casos',
    caso: 'caso',
    casos: 'casos',
  };

  valueCase: string = null;
  openDialog(data: any = null) {
    data = { unidad: this.valueCase, edit: false };
    const dialogRef = this.dialog.open(CrearCasoTareasComponent, {
      data,
      width: '700px',
      maxHeight: '80vh',
      disableClose: true,
      panelClass: 'modalVerTarea',
    });
    dialogRef.afterClosed().subscribe(async (response: any) => {
      // this.getCasos()
      await this.changedCheckbox2(this.actualFilter)
    })
  }

  ngOnInit(){
    this.permisosStr = this.rolService.permisos.toString();
    this.analista = (this.permisosStr.includes('Analista de Casos Asuntos Internos') || this.permisosStr.includes('Analista de Casos Asuntos Externos') ||this.permisosStr.includes('Analista de Casos Inteligencia') || this.permisosStr.includes('Analista de Gestión de Fraudes') )
    this.gerente = (this.permisosStr.includes('Admininistrador Casos de inteligencia') || this.permisosStr.includes('Administrador Casos de Asuntos Externos') ||this.permisosStr.includes('Administrador Casos de Asuntos Internos') || this.permisosStr.includes('Gerente Gestión de Fraudes') || this.permisosStr.includes('Supervisor Gestión de Fraudes'))
    this.allCasos = [0,0]
    this.getCasos()
  }


  ngOnchange() {}

  getCasos() {
    this._casos.get().subscribe(async(response:any)=>{
      this.casos = []
      this.casos = response
      this.casos = await this.casos.filter((caso: CasoTareaModel)=>{
        // console.log(caso)
        console.log(JSON.stringify(caso).toLowerCase())
        this.search = 'informe de resultado'
        // console.log(this.search)
        // console.log(this.search.toLowerCase())

       JSON.stringify(caso).toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        if(JSON.stringify(caso).toLowerCase().search(this.search) !== -1){
          return caso
        }
        console.log(this.search.search("Blue"))
      }
    )
    console.log(this.casos)

      this.ubicarCasos(this.casos)
      console.log(this.valueCase)
    })
  }

  resetColumns() {
    this.PorAsignar = [];
    this.Bloqueado = [];
    this.Finalizado = [];
    this.EnEjecucion = [];
    this.inteligenciaCount = 0;
    this.retencionCount = 0;
    this.gruposvipCount = 0;
    this.asuntosInternosCount = 0;
    this.retPA = 0;
    this.retB = 0;
    this.retF = 0;
    this.retE = 0;

    this.grupPA = 0;
    this.grupB = 0;
    this.grupF = 0;
    this.grupE = 0;

    this.intPA = 0;
    this.intB = 0;
    this.intF = 0;
    this.intE = 0;
  }

  retPA: number = 0;
  retB: number = 0;
  retF: number = 0;
  retE: number = 0;

  grupPA: number = 0;
  grupB: number = 0;
  grupF: number = 0;
  grupE: number = 0;

  intPA: number = 0;
  intB: number = 0;
  intF: number = 0;
  intE: number = 0;

  asunPA: number = 0;
  asunB: number = 0;
  asunF: number = 0;
  asunE: number = 0;
  ubicarCasos(casos: CasoTareaModel[]) {
    this.resetColumns();
    casos.forEach((caso: CasoTareaModel) => {
      // Columnas
      if (caso.estado === 'Por Asignar') {
        this.PorAsignar.push(caso);
        if (caso.tipo_caso === 'Suministro de información') this.intPA += 1;
        if (caso.tipo_caso === 'Retención de fondos') this.retPA += 1;
        if (caso.tipo_caso === 'Gestión de casos VIP') this.grupPA += 1;
        if (caso.tipo_caso === 'Asuntos internos') this.asunPA += 1;
      }
      if (caso.estado === 'Bloqueado') {
        this.Bloqueado.push(caso);
        if (caso.tipo_caso === 'Suministro de información') this.intB += 1;
        if (caso.tipo_caso === 'Retención de fondos') this.retB += 1;
        if (caso.tipo_caso === 'Gestión de casos VIP') this.grupB += 1;
        if (caso.tipo_caso === 'Asuntos internos') this.asunB += 1;
      }
      if (caso.estado === 'Finalizado') {
        this.Finalizado.push(caso);
        if (caso.tipo_caso === 'Suministro de información') this.intF += 1;
        if (caso.tipo_caso === 'Retención de fondos') this.retF += 1;
        if (caso.tipo_caso === 'Gestión de casos VIP') this.grupF += 1;
        if (caso.tipo_caso === 'Asuntos internos') this.asunF += 1;
      }
      if (caso.estado === 'En Ejecución') {
        this.EnEjecucion.push(caso);
        if (caso.tipo_caso === 'Suministro de información') this.intE += 1;
        if (caso.tipo_caso === 'Retención de fondos') this.retE += 1;
        if (caso.tipo_caso === 'Gestión de casos VIP') this.grupE += 1;
        if (caso.tipo_caso === 'Asuntos internos') this.asunE += 1;
      }
      // Tipos de caso
      if (
        caso.tipo_caso === 'Suministro de información' &&
        caso.estado !== 'Archivado'
      ) {
        this.inteligenciaCount += 1;
      }
      if (
        caso.tipo_caso === 'Retención de fondos' &&
        caso.estado !== 'Archivado'
      ) {
        this.retencionCount += 1;
      }
      if (
        caso.tipo_caso === 'Gestión de casos VIP' &&
        caso.estado !== 'Archivado'
      ) {
        this.gruposvipCount += 1;
      }
      if (
        caso.tipo_caso === 'Asuntos internos' &&
        caso.estado !== 'Archivado'
      ) {
        this.asuntosInternosCount += 1;
      }
    });
  }

  requestDeleteTarea(_id: string, event: any) {
    event.stopPropagation();
    const dialogRef = this.dialog.open(Desicion2Component, {
      width: '500px',
      data: {
        text: `¿Seguro desea eliminar este caso?`,
        title: `Casos`,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'true') this.deleteTarea(_id);
    });
  }

  deleteTarea(_id: string) {
    this._casos.delete(_id).subscribe((response: any) => {
      /* this.getCasos() */
    });
  }

  searchFunc() {
    if (!this.casosOriginal) this.casosOriginal = this.casos;
    this.casos = this.casosOriginal;
    this.casos = this.casos.filter(
      (caso: CasoTareaModel) =>
        JSON.stringify(caso)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) !== -1
    );
  }

  editar(data: CasoTareaModel) {
    //unidad;en que unidad de casos se encuentra
    //edit si es editar o crear(fasle/true)
    data.edit = true;

    const dialogRef = this.dialog.open(CrearCasoTareasComponent, {
      width: '600px',
      maxHeight: '80vh',
      data,
      disableClose: true,
      panelClass: 'modalVerTarea',
    });
    dialogRef.afterClosed().subscribe(async (response: any) => {
      // this.getCasos()
      await this.changedCheckbox2(this.actualFilter);
    });
  }

  changedCheckbox(event: any, checkboxType: string) {
    const check: boolean = event.checked;
    this[checkboxType + 'Check'] = check;
    this.filter();
  }

  filter() {
    if (this.casosOriginal.length === 0) this.casosOriginal = this.casos;
    this.casos = this.casosOriginal;

    const types = [
      { nombre: 'retencion', columna: 'Retención de fondos' },
      { nombre: 'gruposvip', columna: 'Gestión de casos VIP' },
      { nombre: 'inteligencia', columna: 'Suministro de información' },
      { nombre: 'asuntosInternos', columna: 'Asuntos internos' },
    ];
    for (let x in types)
      if (!this[types[x].nombre + 'Check'])
        this.casos = this.casos.filter(
          (caso: CasoTareaModel) => caso.tipo_caso !== types[x].columna
        );
    this.casos = this.casos.filter(
      (caso: CasoTareaModel) =>
        JSON.stringify(caso)
          .toLowerCase()
          .indexOf(this.search.toLowerCase()) !== -1
    );
    this.ubicarCasos(this.casos);
  }

  async drop(event: CdkDragDrop<any[]>,columna:string){
    let administradorDeCasos = this.rolService.permisos.includes('Administrador de Casos')
    let analista = this.rolService.permisos.toString().includes('Analista')
    console.log("Analista",analista)
    const caso: CasoTareaModel = event.previousContainer.data[event.previousIndex]
    if(!caso.asignadoA){
      this._snackBar.open(`Este caso aún se encuentra sin asignar`,'x')
    }
    else if (caso.tipo_caso === 'Suministro de información' && columna === 'Bloqueado') {
      this._snackBar.open(`Este tipo de caso no requiere ser aprobado`,'x')
    }
    else if(
      columna === 'Finalizado' &&
      !await this.verificarSiTodasLasTareasEstanFinalizadas(caso._id)
    ){
      this._snackBar.open(`El caso aún tiene tareas pendientes`,'x')
    }
    else if(
      !administradorDeCasos &&
      !analista
    ){
      this._snackBar.open(`Usuario sin permiso de modificar casos`,'x')
    }else{
      if (event.previousContainer === event.container) {
        moveItemInArray(
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      } else {
        transferArrayItem(
          event.previousContainer.data,
          event.container.data,
          event.previousIndex,
          event.currentIndex
        );
      }
      caso.estado = columna;
      caso.historial.push({
        usuario: `${sessionStorage.getItem('correo')}`,
        realizo: `Paso este caso a '${columna}'`,
        date: new Date(),
      });
      console.log(caso);
      this._casos.put(caso._id, caso).toPromise();
      // this.ubicarCasos(this.casos)
      await this.changedCheckbox2(this.actualFilter);
      await this.selectFilter.resetCount();
      if (columna === 'Finalizado')
        this._notification
          .casoPendienteFinalizar(caso.creadoPor, caso.numero_caso)
          .toPromise();
    }
  }

  async finalizarDelTodo(caso:CasoTareaModel){
    const finalizar = await this.verificarSiTodasLasTareasEstanFinalizadas(caso._id)
    if(finalizar){
      const dialogRef = this.dialog.open(ObservacionFinalComponent,{width:'700px',data:caso})
      dialogRef.afterClosed().subscribe(async()=>{/* this.getCasos() */  await this.changedCheckbox2(this.actualFilter)
        this.selectFilter.resetCount()
      })
    }else{
      this.openSnackBar(`Error aun se encuentran tareas sin completar en el caso.`, `x`)
    }
  }

  async verificarSiTodasLasTareasEstanFinalizadas(caso_id: string){
    const tareaCasos = await this._tareacaso.getByCaso(caso_id)
      .toPromise()
    let tareasOmitidas = 1 // Se omite la tarea "Aprobar Evaluación Especialista"
    let resp = true
    tareaCasos.map( (tarea: any) => {
      if(tarea.estado !== 'Finalizado') {
        if(tareasOmitidas === 0)
          resp = false
        else tareasOmitidas-=1
      }
    })
    return resp
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action);
  }

  openCasosArchivados() {
    this.dialog.open(CasosArchivadosComponent);
  }

  ////////////////////////////
  actualFilter;
  allCasos;
  porasignar;
  ejecucio;
  bloqueado;
  finalizado;

  async changedCheckbox2(value) {
    this.actualFilter = value;
    let data = {
      value,
      correo: sessionStorage.getItem('correo'),
      analista: this.analista,
      gerente: this.gerente,
    };
    await this._casos.getbyFilter(data).subscribe(async (response) => {
      await this.resetColumns();
      this.allCasos = response;
      this.porasignar = this.allCasos[1].asig;
      this.ejecucio = this.allCasos[1].ejec;
      this.bloqueado = this.allCasos[1].bloqu;
      this.finalizado = this.allCasos[1].finali;
      for (let element of this.allCasos[0]) {
        if (element.casos.bloqueado[0] != undefined) {
          this.Bloqueado = this.Bloqueado.concat(
            element.casos.bloqueado[0].tareas
          );
        }
        if (element.casos.porasignar[0] != undefined) {
          this.PorAsignar = this.PorAsignar.concat(
            element.casos.porasignar[0].tareas
          );
        }
        if (element.casos.finalizado[0] != undefined) {
          this.Finalizado = this.Finalizado.concat(
            element.casos.finalizado[0].tareas
          );
        }
        if (element.casos.ejecucio[0] != undefined) {
          this.EnEjecucion = this.EnEjecucion.concat(
            element.casos.ejecucio[0].tareas
          );
        }
      }
      this.selectFilter.resetCount();
    });
  }
  filter2() {
    if (this.casosOriginal.length === 0) this.casosOriginal = this.casos;
    this.casos = this.casosOriginal;
    const types: any = this.selectFilter.actualUnidad[0].tipo_caso;
    for (let x in types) {
      if (types[x].checked) {
        this.casos = this.casos.filter(
          (caso: CasoTareaModel) => caso.tipo_caso !== types[x].name
        );
        this.casos = this.casos.filter(
          (caso: CasoTareaModel) =>
            JSON.stringify(caso)
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) !== -1
        );
      }
    }
  }
}
